import Backbone from 'backbone';
import { dashboardConfig } from '../config/dashboard-config';
import { Dashboard } from '../dashboard/dashboard-view';
import template from './dashboard-page-template.pug';

export class DashboardPage extends Backbone.View {
  initialize({
    perfMarker,
    dateFilterState,
    filterAgent,
    currentCampaign,
    newCardsConfig = null,
    welcomeCardsConfig,
    pageName,
    onMounted = null,
    scope,
    accountsMode,
    newI18n,
    preexecuteFlag = false,
    preferenceService,
  }) {
    this.perfMarker = perfMarker;
    this.dateFilterState = dateFilterState;
    this.filterAgent = filterAgent;
    this.currentCampaign = currentCampaign;
    this.pageName = pageName;
    this.perfMarker.willInit();
    this.newCardsConfig = newCardsConfig;
    this.welcomeCardsConfig = welcomeCardsConfig;
    this.onMounted = onMounted;
    this.scope = scope;
    this.preexecuteFlag = preexecuteFlag;
    this.accountsMode = accountsMode;
    this.newI18n = newI18n;
    this.preferenceService = preferenceService;
    this.createDashboard();
  }

  createDashboard() {
    this.dashboard = new Dashboard({
      name: dashboardConfig.defaultName,
      perfMarker: this.perfMarker,
      dateFilterState: this.dateFilterState,
      filterAgent: this.filterAgent,
      currentCampaign: this.currentCampaign,
      newCardsConfig: this.newCardsConfig,
      welcomeCardsConfig: this.welcomeCardsConfig,
      pageName: this.pageName,
      onMounted: this.onMounted,
      scope: this.scope,
      accountsMode: this.accountsMode,
      newI18n: this.newI18n,
      preexecuteFlag: this.preexecuteFlag,
      preferenceService: this.preferenceService,
    });
  }

  recreateView() {
    if (!this.isRemoved) {
      this.dashboard.remove();
      this.createDashboard();
      this.$el.html(template());

      this.$el.append(this.dashboard.$el);
      this.dashboard.render();
    }
  }

  updateScope() {
    this.recreateView();
  }

  updateMode({ accountsMode }) {
    this.accountsMode = accountsMode;
    this.recreateView();
  }

  render() {
    this.perfMarker.willRender();


    this.$el.html(template());

    this.$el.append(this.dashboard.$el);
    this.dashboard.render();

    return this;
  }

  remove() {
    this.dashboard.remove();
    this.$el.remove();
    this.isRemoved = true;
  }
}
